<!-- Reusable modal using content projection.
     Usage examples (parent):
     <ds-modal [(visible)]="showModal" [title]="'Edit item'" [variant]="'error'" (confirmed)="onConfirm($event)">
       <div modal-body>...body html...</div>
       <div modal-footer>...footer buttons...</div>
     </ds-modal>
-->
      
@if (modalInput?.visible) {
  <div class="modal fade  modal-overlay d-block show" tabindex="-1" role="dialog" [attr.aria-labelledby]="modalInput?.ariaLabelledBy" aria-modal="true">
    <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable eod-ds-modal" [ngClass]="{
      'modal-sm': modalInput?.size === 'sm',
      'modal-md': modalInput?.size === 'md',
      'modal-lg': modalInput?.size === 'lg',
      'modal-xl': modalInput?.size === 'xl',
      'modal-xxl': modalInput?.size === 'xxl'
    }">
      <div class="modal-content">
        <div class="modal-header" [ngClass]="{
          'modal-header-error': modalInput?.variant === 'error',
          'modal-header-success': modalInput?.variant === 'success',
          'modal-header-warning': modalInput?.variant === 'warning'
          }">
          <ng-content select="[modal-header]"></ng-content>
          @if (!hasProjectedHeader && (modalInput?.title || modalInput?.headerIconSrc || headerIcon)) {
            <h5 class="modal-title" [id]="modalInput?.ariaLabelledBy">
              @if (modalInput?.headerIconSrc || headerIcon) {
                <img [src]="modalInput?.headerIconSrc || headerIcon" [alt]="modalInput?.headerIconAltOverride || headerIconAlt"/>
              }
              {{ modalInput?.title }}
            </h5>
          }
          @if(!modalInput?.hiddenCloseIcon) {
          <button type="button" class="btn-close" aria-label="Close" (click)="close()">
            <img [src]="ICONS.CLOSE" alt="">
          </button>
         }
        </div>

        <div class="modal-body">
          <ng-content select="[modal-body]"></ng-content>
        </div>


          <div class="modal-footer">
            <ng-content select="[modal-footer]"></ng-content>
          </div>

      </div>
    </div>
  </div>

  <!-- backdrop -->
  <div class="modal-backdrop fade show"></div>
}


